import { ReducerRegistry } from 'store';
import {
  APP_LOAD,
  REDIRECT,
  LOGOUT,
  LOGIN,
  RESET_PASSWORD,
  CLEAR,
} from '../types';
import { REHYDRATE } from 'redux-persist';

const INITIAL_STATE = {
  isAuthenticated: false,
  resetDetails: null,
};

export const commonReducer = ReducerRegistry.register(
  'common',
  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case APP_LOAD:
        return {
          ...state,
          isAuthenticated: action.isAuthenticated,
          user: action.user,
        };
      case REDIRECT:
        return {
          ...state,
          redirectTo: null,
        };
      case RESET_PASSWORD:
        return {
          ...state,
          resetDetails: action?.payload,
        };
      case LOGIN:
        return {
          ...state,
          isAuthenticated: action.isAuthenticated,
          user: action.user,
          redirectTo: '/',
          resetDetails: null,
        };
      case LOGOUT:
        return {
          ...state,
          redirectTo: '/login',
          isAuthenticated: false,
        };
      case CLEAR:
        return INITIAL_STATE;
      case REHYDRATE:
        const persistedCommon = action?.payload?.common || INITIAL_STATE;
        return { ...state, ...persistedCommon };
      default:
        return state;
    }
  }
);
